module.exports = __webpack_public_path__ + "img/logo.8300e28d.svg";